export const DISCOUNTS = [
  { value: '10', label: 'Descuento del 10% o mas' },
  { value: '20', label: 'Descuento del 20% o mas' },
  { value: '30', label: 'Descuento del 30% o mas' },
  { value: '40', label: 'Descuento del 40% o mas' },
  { value: '50', label: 'Descuento del 50% o mas' },
  { value: '60', label: 'Descuento del 60% o mas' },
  { value: '70', label: 'Descuento del 70% o mas' },
];
